import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Select,
	Input,
	InputLabel,
	TableSortLabel,
	MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
	Card,
	CardContent,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";


const useStyles = makeStyles({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
});

const PurchaseOrderReturn = () => {
	const classes = useStyles();
	const [supplier, setSupplier] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const [supplierFilter, setSupplierFilter] = useState([])
	const [warehouseFilter, setWarehouseFilter] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [btnDisabled, setBtnDisabled] = useState(true);
	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.suppliername,
	};

	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));

	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: (option) => option.description
	};
	
	const getSupplierList = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'get_supplier_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		});
		setSupplier(result.data.data);
	}
	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const setSupplierDetails = (supplier_object) => {
		//update value of supplier address, etc
		setSupplierFilter(supplier_object); //id filter for PO = supplier_object.id (since its an object)
		//display contanct number, customer address and mode of payment
		getSupplierList();
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if (supplierFilter?.id && warehouseFilter && selectedDate) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [supplierFilter, warehouseFilter, selectedDate]);

	const data = async () => {
		//get data for location/warehouse dropdown
		const res = await axios.get(process.env.REACT_APP_API_URL+'get_warehouse_list');
		setWarehouse(res.data.data);
		getSupplierList();
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order Return</h4>
			</div>
			{supplier && warehouse ? (			<div className="page-container">
				<Grid container spacing={3}>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Purchase Order Return From</h4>
								<form noValidate autoComplete="off">
									{/*<FormHelperText style={{marginBottom: "15px"}}>Set Branch ID first before selecting Supplier</FormHelperText>
									<TextField
									style={{marginBottom: "-2px"}}
										id="outlined-basic"
										label="Branch ID No"
										variant="outlined"
										value={branchIdNo}
										type="text"
										className={classes.field}
										onChange={(e) => setBranchIdNo(e.target.value)}
										onBlur={()=> getSupplierList()}
									/> */}
									<Autocomplete
										{...selectSupplierProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Select Supplier"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												// console.log(newValue);
												setSupplierDetails(newValue);
											}else{
												//console.log('hehe');
												setSupplierDetails(null);
											}
										}}
									/>
									<TextField
										id="outlined-basic"
										label="Contact Number"
										variant="outlined"
										type="text"
										className={classes.field}
										value={supplierFilter?.contactno || ''} //to avoid label overlapping bug
										InputProps={{
											readOnly: true,
										  }}
									/>
									<TextField
										id="outlined-basic"
										label=" Mode of Payment"
										variant="outlined"
										className={classes.field}
										value={supplierFilter?.mode_of_payment || ''} //to avoid label overlapping bug
										InputProps={{
											readOnly: true,
										  }}
									/>
									<TextField
										id="outlined-basic"
										label="Address"
										variant="outlined"
										multiline
										rows={4}
										className={classes.field}
										value={supplierFilter?.address || ''} //to avoid label overlapping bug
										InputProps={{
											readOnly: true,
										  }}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Purchase Order Return Information</h4>
								<form noValidate autoComplete="off">
									<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Date"
											value={selectedDate}
											onChange={handleDateChange}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											inputProps={{readOnly:"true"}}
										/>
									</MuiPickersUtilsProvider>
									{/* <Autocomplete
										{...selectShippingProps}
										id="auto-complete-1"
										autoComplete
										includeInputInList
										renderInput={(params) => (
											<TextField
												{...params}
												label="Select Shipping"
												variant="outlined"
											/>
										)}
									/> */}
									<Autocomplete
										{...selectLocationProps}
										id="auto-complete-2"
										autoComplete
										includeInputInList
										renderInput={(params) => (
											<TextField
												{...params}
												margin="normal"
												label="Select Location"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												// console.log(newValue.id);
												setWarehouseFilter(newValue.id);
											}else{
												//console.log('hehe');
												setWarehouseFilter(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" className={classes.buttonContainer}>
						
						{btnDisabled ? (<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    						root: classes.root, 
        					disabled: classes.disabled}}>
							Next
							</ColorButton>) : (<NavLink to={"/purchases/purchases-order-return-information/"+supplierFilter?.id+"/"+warehouseFilter+"/"+selectedDate}>
							<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    						root: classes.root, 
        					disabled: classes.disabled}}>
							Next
							</ColorButton>
						</NavLink>)}
						{/* <NavLink to={"/purchases/purchases-order-return-information/"+supplierFilter?.id+"/"+warehouseFilter+"/"+selectedDate}>
							<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    						root: classes.root, 
        					disabled: classes.disabled}}>
							Next
							</ColorButton>
						</NavLink> */}
					</Grid>
				</Grid>
			</div>
		) : (<Preloader />)}
		</div>
	);
};
export default PurchaseOrderReturn;
